<section class="testimonials">

    <div class="container-redesign">

        <div class="testimonials__grid">

            <article
                class="testimonials__card"
                *ngFor="let testimonial of testimonials; trackBy: trackByAuthor">

                <div class="testimonials__stars">
                    ★★★★★
                </div>

                <h3 class="testimonials__title">
                    {{ testimonial.title }}
                </h3>

                <p class="testimonials__description">
                    {{ testimonial.description }}
                </p>

                <span class="testimonials__author">
                    {{ testimonial.author }}
                </span>

            </article>

        </div>

    </div>

</section>